import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppRoutingModule } from "./app-routing.module";

import { AppComponent } from "./app.component";
import { ErrorPageComponent } from "./shared/error-page/error-page.component";

import { HIGHLIGHT_OPTIONS } from "ngx-highlightjs";
import { LayoutModule } from "./modules/layout/layout.module";
import { AuthGuard } from "./core-features/auth-guard/auth.guard";
import { HttpClientModule } from "@angular/common/http";
import { DashboardModule } from "./modules/dashboard/dashboard.module";
import { IndividualConfig, ToastrModule, ToastrService } from "ngx-toastr";
import { AddSheetComponent } from "./modules/dashboard-builder/components/add-sheet/add-sheet.component";
import { AddWidgetComponent } from "./modules/dashboard-builder/components/add-widget/add-widget.component";
import { DashboardBuilderComponent } from "./modules/dashboard-builder/pages/dashboard-builder/dashboard-builder.component";
import { SharedService } from "./shared/services/shared.service";
//import { AppUrlsService } from 'src/environment/environment.prod';

// const toastrService = {
//   success: (
//     message?: string,
//     title?: string,
//     override?: Partial<IndividualConfig>
//   ) => { },
//   error: (
//     message?: string,
//     title?: string,
//     override?: Partial<IndividualConfig>
//   ) => { },
// };

@NgModule({
  declarations: [
    AppComponent,
    ErrorPageComponent
    //AddSheetComponent,
    //AddWidgetComponent,
    // DashboardBuilderComponent,
    //SheetComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,

    LayoutModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      positionClass: "toast-top-right"
    })
  ],
  providers: [
    AuthGuard,
    ToastrService,
    {
      provide: HIGHLIGHT_OPTIONS, // https://www.npmjs.com/package/ngx-highlightjs
      useValue: {
        coreLibraryLoader: () => import("highlight.js/lib/core"),
        languages: {
          xml: () => import("highlight.js/lib/languages/xml"),
          typescript: () => import("highlight.js/lib/languages/typescript"),
          scss: () => import("highlight.js/lib/languages/scss")
        }
      }
    },
    SharedService
    // { provide: ToastrService, useValue: toastrService }
    // { provide: ToastrService }
  ],

  bootstrap: [AppComponent]
})
export class AppModule {}
